import '../../static/css/templ/header.css';
import {
    ThinCaretDownIcon,
    ThinLogoutIcon,
    ThinMenuIcon, ThinPersonIcon, ThinSettingIcon,
} from "../icons/material-icons";
import {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ClickOutsideDetector from "../clickOutside/click-outside";
import {HideProgressLoading, ShowProgressLoading} from "./architecture";
import {AuthRedirectAdmins, PostJSON} from "../api/webservice";
import {Apis} from "../api/url";
import {ShowConnectionFailed} from "./connection-failed";

export const Header = (props: {panel:'admin'|'parent',name:string,role:string,headerTitle:string}) => {
    const [headerMenuShown, headerMenuShownChanged] = useState('');
    const {pathname} = useLocation();
    useEffect(() => {
        headerMenuShownChanged('');
    }, [pathname]);
    const closeSideOnMobile = () => {
        (document.querySelector('.sidenav') as HTMLElement).classList.remove('open');
        (document.querySelector('.sidenav-underlay') as HTMLElement).classList.remove('active');
    };
    let navigate = useNavigate();
    const signOut = () => {
        const panel = props.panel;
        ShowProgressLoading();
        PostJSON(
            Apis.server + (panel === 'admin' ? '/core/admins/account/logout' : '/core/parents/account/logout'),
            {},
            true,
            (d:any)=>{
                localStorage.removeItem(panel === 'admin' ? 'myAuth' : 'parentAuth');
                HideProgressLoading();
                navigate('/',{replace:true});
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            ()=>{
                navigate('/',{replace:true});
            },
            panel === 'admin' ? 'admins' : 'parents',
        ).then(void 0);
    };
    return (
        <>
            <header className="header">
                <div className="header-start">
                    <button className="header-btn d-md-none" onClick={() => {
                        const s = (document.querySelector('.sidenav') as HTMLElement);
                        const u = (document.querySelector('.sidenav-underlay') as HTMLElement);
                        if (s.classList.contains('open')) {
                            s.classList.remove('open');
                            u.classList.remove('active');
                        } else {
                            s.classList.add('open');
                            u.classList.add('active');
                        }
                    }}>
                        <ThinMenuIcon/>
                    </button>
                    <Link to={"/" + (props.panel === 'admin' ? 'admins/' : 'students/')} className="header-logo">
                        <i style={{backgroundImage: 'url(/logo.png)'}}/>
                        <b className="f-roboto">{props.headerTitle}</b>
                        {/*<em className="f-roboto d-none">آزمایشی</em>*/}
                    </Link>
                </div>
                <div className="header-desktop">
                    <button
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            headerMenuShownChanged(v => 'settings' === v ? '' : 'settings');
                            closeSideOnMobile();
                        }}
                        className={"header-side-link header-link-svg-with-rotate" + (headerMenuShown === 'settings' ? ' active' : '')}>
                        <ThinCaretDownIcon/>
                    </button>
                </div>
            </header>
            {
                headerMenuShown === 'settings' ?
                    <ClickOutsideDetector
                        onClickOutside={() => {
                            headerMenuShownChanged('');
                            closeSideOnMobile();
                        }}
                        className="header-side-link-open active">
                        <div className="header-side-link-open-account-a">
                            <div className="header-side-link-open-account-a-avatar">
                                <ThinPersonIcon/>
                            </div>
                            <b>{props.name}</b>
                            <span>{props.role}</span>
                        </div>
                        {
                            props.panel === 'parent' ?
                                <Link to={`/students/profile`}>
                                    <div className="svg-c">
                                        <ThinSettingIcon/>
                                    </div>
                                    <span>پروفایل</span>
                                </Link> : null
                        }
                        <button onClick={signOut}>
                            <div className="svg-c">
                                <ThinLogoutIcon/>
                            </div>
                            <span>خروج از حساب</span>
                        </button>
                    </ClickOutsideDetector> : null
            }
        </>
    );
};